export default __webpack_public_path__ + "static/media/gameplay-icon-3.5d2bbb01.gif";